import { getAlternativeRateCost } from './helpers/alternative-rate-helpers';

export const getRecommendedService = (alternativeRates, isRateShopperRecommendationsEnabled) => {
  /*
   If we have a rate shopper recommendation, prefer it over finding the cheapest alternative rate. This allows us to
   recommend the service that rate shopper chose, without actually recommending the rate shopper. The primary use case
   for this is when the user has the rate shopper disabled.
   */
  const rateShopperServiceIdRecommendation = isRateShopperRecommendationsEnabled ? alternativeRates.rateShopper?.serviceId : undefined;
  if (rateShopperServiceIdRecommendation) {
    const rateShopperService = alternativeRates.service.find((x) => x.shippingServiceId === rateShopperServiceIdRecommendation);

    if (rateShopperService) {
      return rateShopperService;
    }
  }

  return alternativeRates.service.reduce((cheapestRate, rate) => {
    if (!cheapestRate) {
      return rate;
    }

    return getAlternativeRateCost(rate.rate) < getAlternativeRateCost(cheapestRate.rate) ? rate : cheapestRate;
  }, undefined);
};
